import { onUnmounted, ref } from 'vue';
import { useReducedMotion } from '@/v2/composables/useReducedMotion.js';

export function useAnimation() {
  const { isReducedMotion } = useReducedMotion();
  const isAnimationActive = ref(!isReducedMotion.value);
  let timeoutId = null;

  const startTimedAnimation = (timeoutMs = 5000, cleanupCallback) => {
    if (isReducedMotion.value) {
      isAnimationActive.value = false;
      return;
    }

    isAnimationActive.value = true;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      isAnimationActive.value = false;
      if (cleanupCallback) {
        cleanupCallback();
      }
    }, timeoutMs);
  };

  onUnmounted(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  });

  return {
    isAnimationActive,
    startTimedAnimation
  };
}
